import React from 'react';
import TagSelectListIcon from '@common/assets/svg/tag-list-icon.svg';
import { FormField } from '@common/components/hilbi-form';
import Select from './../select';
import { useIntl } from 'react-intl';
import { readableColor } from 'polished';
import TagSelectOption from './../options/tag-select-option';
import { css } from 'styled-components';
import { TAG_STYLES } from '@common/components/tag/tag.styled';
import { ITagSelectOption } from './../options/types';

type TagSelectProps = {
  name: string;
  disabled: boolean;
  tagOptions: any[];
  setValue: (selectedTag: ITagSelectOption | null) => void;
  value: ITagSelectOption | null;
  error?: string;
};

const SELECT_CUSTOM_STYLES = {
  singleValue: (_: any, { data }: { data: { color: string } }) => {
    return {
      backgroundColor: data.color,
      color: readableColor(data.color),
    };
  },
};

const TagSelect: React.FunctionComponent<TagSelectProps> = ({
  name,
  tagOptions,
  disabled,
  value,
  setValue,
  error,
}) => {
  const { formatMessage } = useIntl();

  return (
    <FormField
      disabled={disabled}
      error={error ? formatMessage({ id: error }) : ''}
      icon={TagSelectListIcon}
    >
      <Select
        name={name}
        onChange={setValue}
        options={tagOptions}
        placeholder={formatMessage({
          id: 'reservation_form_tag_list_placeholder',
        })}
        maxMenuHeight={100}
        components={{ Option: TagSelectOption }}
        value={value}
        styles={SELECT_CUSTOM_STYLES}
        isClearable={true}
        isSearchable={false}
        isDisabled={disabled}
        customCss={css`
          .ui-react-select__menu {
            max-height: 150px;
          }
          .ui-react-select__menu-list {
            max-height: 150px;
          }

          .ui-react-select__single-value {
            ${TAG_STYLES};
          }
        `}
      />
    </FormField>
  );
};

export default React.memo(TagSelect);
